
const STEP_INTERNET = {
  id: 'internet',
  label: 'Plan',
  pages: ['progressiveplan'],
};

const STEP_SERVICES = {
  id: 'services',
  label: 'Services',
  pages: ['addons'],
};


const NSE_STEP_VERIFY_REVIEW = {
  id: 'verifyReview',
  label: 'Verify & Review',
  pages: ['contactinfo', 'createprofile', 'creditcheck', 'expresscheckout'],
};

const AAL_STEP_VERIFY_REVIEW = {
  id: 'verifyReview',
  label: 'Review',
  pages: ['expresscheckout'],
};

const STEP_CHECKOUT = {
  id: 'checkout',
  label: 'Checkout',
  pages: ['payment', 'expresstos'],
};

export const NSE_STEPS = [
  STEP_INTERNET,
  STEP_SERVICES,
  NSE_STEP_VERIFY_REVIEW,
  STEP_CHECKOUT,
];


export const AAL_STEPS = [
  STEP_INTERNET,
  STEP_SERVICES,
  AAL_STEP_VERIFY_REVIEW,
  STEP_CHECKOUT,
];

export const STEP_PAGE_MAP = {
  internet: 'progressiveplan.html',
  services: 'addons.html',
  verifyReview: 'expresscheckout.html',
  checkout: 'payment.html',
};

export const getStepRedirectPage = (stepId) => STEP_PAGE_MAP[stepId];

const DATA_TRACK_NAMES = {
  internet: 'Internet',
  services: 'Services',
  verifyReview: 'Verify & Review',
  checkout: 'Checkout',
};

export const getStepDataTrack = (stepId) => {
  const name = DATA_TRACK_NAMES[stepId];
  if (!name) return undefined;
  return JSON.stringify({ type: 'link', name: `${name} - progressbar nav` });
};

export const STEPPER_SUPPRESSION_RULES = [
  { page: 'addons', requiresParam: 'service' }, // Services sub-options: Perks / YouTubeTV / WHW
  { page: 'shipping' }, // Shipping option edit (from Order Review)
  { page: 'appointment' }, // Pro-setup scheduling (from Order Review)
];


export const shouldSuppressStepper = (pageName, searchParams) =>
  STEPPER_SUPPRESSION_RULES.some((rule) => {
    if (rule.page !== pageName) return false;
    if (rule.requiresParam) return Boolean(searchParams?.has?.(rule.requiresParam));
    return true;
  });

/**
 * Resolves the explicit "Back" target for pages where stepper is suppressed.
 * This avoids relying on browser history depth (which can require multiple
 * back clicks when users navigate within sub-pages).
 *
 * @param {string} pageName - Page slug from getUrlName(location.pathname).
 * @param {URLSearchParams} [searchParams] - Current URL query params.
 * @returns {string|null} Relative target page (e.g. addons.html) or null.
 */
export const getSuppressedStepperBackTarget = (pageName, searchParams) => {
  if (pageName === 'addons') {
    const params = new URLSearchParams(searchParams?.toString?.() || '');
    params.delete('service');
    const query = params.toString();
    return query ? `addons.html?${query}` : 'addons.html';
  }

  if (pageName === 'shipping' || pageName === 'appointment') {
    return 'expresscheckout.html';
  }

  return null;
};
